import PropTypes from 'prop-types';

const formTripShape = {
  origin: PropTypes.shape({
    onChange: PropTypes.func,
    error: PropTypes.arrayOf(PropTypes.node),
    value: PropTypes.string,
  }),
  destination: PropTypes.shape({
    onChange: PropTypes.func,
    error: PropTypes.arrayOf(PropTypes.node),
    value: PropTypes.string,
  }),
  date: PropTypes.shape({
    onChange: PropTypes.func,
    initialValue: PropTypes.string,
    value: PropTypes.string,
    touched: PropTypes.bool,
    onFocus: PropTypes.func,
  }),
  cabinClass: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.string,
    initialValue: PropTypes.string,
  }),
  bookingClass: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.arrayOf(PropTypes.string),
    initialValue: PropTypes.arrayOf(PropTypes.string),
  }),
  alliancePreferences: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.arrayOf(PropTypes.string),
  }),
  id: PropTypes.shape({
    value: PropTypes.number,
  }),
};

export default formTripShape;
